import { Component } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';

export const VERSION_NUMBER: string = "1.0.0";

@Component({
    selector: 'app-global-version-number',
    standalone: true,
    imports: [COMMON_IMPORTS],
    template: `
    <div class="version-container">
      <span class="version-text">v{{ versionNumber }}</span>
    </div>
  `,
    styles: [`
    .version-container {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    
    .version-text {
      font-size: 0.75rem;
      color: var(--text-color-secondary);
      font-weight: 400;
      opacity: 0.7;
    }
  `]
})
export class GlobalVersionNumberComponent {
    versionNumber = VERSION_NUMBER;
}
